import React, { Children, cloneElement, isValidElement } from 'react';
export const AspectBox = ({ ratio, children }) => {
    return (React.createElement(React.Fragment, null, Children.map(children, (child) => {
        if (isValidElement(child)) {
            return cloneElement(child, Object.assign(Object.assign({}, child.props), { style: Object.assign(Object.assign({}, child.props.style), { aspectRatio: ratio.split(':').join('/') }) }));
        }
    })));
};
//# sourceMappingURL=AspectBox.js.map